export default function toUsd(amount: number | string) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  return formatter.format(typeof amount === 'number' ? amount : parseFloat(amount));
}
